module.exports = __webpack_public_path__ + "static/media/5.12.86ce11b3.png";